
// Session timeout validation constants (in seconds)
export const SESSION_TIMEOUT_CONSTANTS = {
    // Default values
    DEFAULT_ACTIVITY_TIMEOUT: 60, // 1 minute
    DEFAULT_TTL: 86400 * 7, // 7 days

    // Minimum values
    MIN_ACTIVITY_TIMEOUT: 60, // 1 minute
    MIN_TTL: 3600, // 1 hour

    // Maximum values
    MAX_ACTIVITY_TIMEOUT: 86400, // 24 hours
    MAX_TTL: 2592000, // 30 days
} as const

// Device limit constants
export const DEVICE_LIMIT_CONSTANTS = {
    DEFAULT: 5,
    MIN: 1,
    MAX: 100
} as const

// Login retry limit constants  
export const LOGIN_RETRY_CONSTANTS = {
    DEFAULT: 5,
    MIN: 3,
    MAX: 20
} as const

export type AppData = {
    id?: string
    name?: string
    icons?: string
    iconl?: string
    desc?: string
    status?: string
    clients?: ClientData[] | null
}

export type ClientData = {
    id: string
    desc: string
    secret: string
    redirect?: string
    platform?: string
    domain?: string
    custom_hash?: boolean
    session_activity_timeout?: number // Session activity timeout in seconds
    session_ttl?: number // Session TTL in seconds
    allow_delete?: boolean // Allow users to delete their accounts
    allow_multiple_sessions?: boolean // Allow users to have multiple active sessions
    device_limit?: number // Maximum number of devices per user
    login_retry_limit?: number // Maximum login retry attempts before blocking
    new_session_on_reauth?: boolean // if true, reauth creates new session ID
}

export type RoleData = {
    id?: string
    desc?: string
    name?: string
}